import { IFtpSettings } from "../../common-interfaces/ftp-settings"
import { PosterSize } from "../../common-types/poster-size";
import { PosterType } from "../../common-types/poster-type";
import { availableExaktaSKUs as availableSKUs } from "./skus/available";

export type ExaktaTShirtPrintLocations = 'FRONT' | 'BACK' | 'FRONT_AND_BACK';
export type ExaktaTShirtSize = 'S' | 'M' | 'L' | 'XL' | '2XL' | '3XL' | '4XL' | '5XL';

export const availableTShirtSizes: ExaktaTShirtSize[] = ['S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];

export interface IExaktaTShirtDetails {
    partnerSku?: string;
    size?: ExaktaTShirtSize;
    color?: string;
    model?: string;
}


export type ShippingAlias =
    'dhlservicepointb2c-se'
    | 'bringpickupparcelbulk-se-dk-fi'
    | 'dhlparcelconnectb2c-eu'
    | 'bringpickupparcelbulk-se-dk-fi'
    | 'dhlparcelconnectbulkb2c-de'
    | 'bifrosttrackedstor-eu'
    | 'bifrosttrackedmaxi-eu'
    | 'bifrosttrackedmaxi-noneu'
    | 'fedexintconplus-ww-b2c'
    | 'dbschenker_parcelshop_domestic_b2c'
    | 'EXAKTA_B2B';


export const frameDimensions = ({ width, height }: { width: string, height: string }) => {
    let widthNumber = parseInt(width);
    let heightNumber = parseInt(height);
    if (widthNumber < heightNumber)
        return `${widthNumber}x${heightNumber}`;
    else
        return `${heightNumber}x${widthNumber}`;
}


export const getPosterSizeByTypeAndSku = (posterType: PosterType, sku: string) : PosterSize => {
    if (['POSTER', 'CANVAS'].includes(posterType)) {
        if (sku && sku.length) {
            let size = sku.split('_')[1];

            return size as PosterSize;
        }
    }
    return null;
}

export const availableExaktaSKUs = availableSKUs;

export interface IExaktaSettings {
    customerName: string,
    useLegacyDispatchProcessing?: boolean,
    xmlFilePrefix?: string,
    printFileBaseUrl?: string,
    ftpSettings?: IFtpSettings
    carrier: string
}


export interface IExaktaTrackingInfo {
    orderId: string,
    carrier?: string,
    trackingNumber: string,
    trackingUrl: string
}